import { Model } from "@vuex-orm/core";
import config from "../configs/VotingCategory";
import BuildingOwnerVotingRight from "./BuildingOwnerVotingRight";

export default class VotingCategory extends Model {
  static get entity() {
    return "voting_categories";
  }
  static fields() {
    return {
      id: this.attr(null),
      agency_id: this.attr(null),
      building_id: this.attr(null),
      name: this.attr(null),
      slug: this.attr(null),
      is_charge_generale: this.attr(null),
      created: this.attr(null),
      updated: this.attr(null),
      deleted: this.attr(null), // ???: ..
      building_owner_voting_rights: this.hasMany(BuildingOwnerVotingRight, "voting_category_id"),
    };
  }
  static get apiConfig() {
    return config;
  }
}
